import { render, staticRenderFns } from "./CustomerPrivateFormulationList.vue?vue&type=template&id=aac71c0e&scoped=true&"
import script from "./CustomerPrivateFormulationList.vue?vue&type=script&lang=js&"
export * from "./CustomerPrivateFormulationList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPrivateFormulationList.vue?vue&type=style&index=0&id=aac71c0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac71c0e",
  null
  
)

export default component.exports